/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ range: NonNullable<unknown> }} Metric_Avg_Blocktime_Name_RangeInputs */



/**
* | output |
* | --- |
* | "Average Block Time ({range})" |
*
* @param {Metric_Avg_Blocktime_Name_RangeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const metric_avg_blocktime_name_range = /** @type {((inputs: Metric_Avg_Blocktime_Name_RangeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metric_Avg_Blocktime_Name_RangeInputs, { locale?: "en" }, {}>} */ ((i, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ (`Average Block Time (${i?.range})`)
});